import {Injectable, inject} from '@angular/core'
import {Order} from '@models/order/order'
import {Outlet} from '@models/outlet'
import {EmbeddedClientService} from '@service/embeddingService/embedded-client.service'
import {EmbeddedStoreService} from '@service/embeddingService/embedded-store.service'
import {OrderService} from '@service/orders/order/order.service'

/**
 * Variante embebida de `OrderService`.
 *
 * @description
 * En modo embebido los pedidos vienen en el payload del host y están disponibles en
 * `EmbeddedStoreService.orders()`. Este servicio filtra/selecciona dentro de ese array
 * en memoria sin consultar PouchDB. `showHeaderOrderDetail` se fija a `false` porque el
 * detalle del pedido se renderiza dentro del layout del host.
 *
 * Sobrescribe también `getAddressLabel` para mostrar la dirección completa en pantallas
 * no-resumen.
 */
@Injectable({
  providedIn: 'root',
})
export class OrderEmbeddedService extends OrderService {
  showHeaderOrderDetail = false
  private readonly orderEmbeddedStoreService: EmbeddedStoreService = inject(EmbeddedStoreService)
  readonly embeddingService: EmbeddedClientService = inject(EmbeddedClientService)

  protected override getOrdersInit = async (): Promise<any[]> => this.orderEmbeddedStoreService.orders()

  override getOrder = (orderId: string): Promise<Order> =>
    Promise.resolve(
      this.orderEmbeddedStoreService.orders()?.filter(order => order.id === orderId || order.orderId === orderId)[0]
    )

  getOutletOrders = async (outletId: string, useSingleton = false): Promise<Order[]> =>
    this.orderEmbeddedStoreService
      .orders()
      .filter(order => order.outletId === outletId?.toString() || order.outletMainId === outletId.toString())

  getOrdersUntilDate = async (date: number): Promise<Order[]> =>
    this.orderEmbeddedStoreService.orders().filter(o => o.orderDate > date)

  override getAddressLabel = (order: Order, outlet: Outlet, isSummary: boolean): string =>
    isSummary ? outlet?.address_text : this.getDeliveryAddressLabel(order)
}
